import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'

// Basic selectors
export const selectProductsState = (state: RootState) => state.products
export const selectProducts = (state: RootState) => state.products.items
export const selectSelectedProduct = (state: RootState) => state.products.selectedProduct
export const selectProductsLoading = (state: RootState) => state.products.loading
export const selectProductsError = (state: RootState) => state.products.error
export const selectProductsFilterParams = (state: RootState) => state.products.filterParams

// Memoized selectors
export const selectProductById = createSelector(
  [selectProducts, (state: RootState, productId: string) => productId],
  (products, productId) => products.find(product => product.id === productId)
)

export const selectProductsByCategory = createSelector(
  [selectProducts, (state: RootState, categoryId: string) => categoryId],
  (products, categoryId) => products.filter(product => product.categoryId === categoryId)
)

export const selectProductsCount = createSelector(
  [selectProducts],
  (products) => products.length
)
